import { NavLink } from 'react-router-dom';
import { useLangContext } from '../../../context/LangProvider';
import { routes } from '../../../routes/mainRoutes';
import s from './AuthLinkGroup.module.scss';

const AuthLinkGroup = ({ matchUrl }) => {
  const { language } = useLangContext();

  return (
    <div className={s.container}>
      {matchUrl === routes.REGISTER ? (
        <p className={s.linkTitle}>
          {language.authForm.signupQuestion}
          <NavLink to={routes.LOGIN} className={s.link}>
            {language.authForm.signupLink}
          </NavLink>
        </p>
      ) : (
        <p className={s.linkTitle}>
          {language.authForm.signinQuestion}
          <NavLink to={routes.REGISTER} className={s.link}>
            {language.authForm.signinLink}
          </NavLink>
        </p>
      )}
      {matchUrl === routes.RESET_PASSWORD || matchUrl === routes.SEND_EMAIL ? (
        <p className={s.linkTitle}>
          {language.authForm.signupQuestion}
          <NavLink to={routes.LOGIN} className={s.link}>
            {language.authForm.signupLink}
          </NavLink>
        </p>
      ) : (
        <p className={s.linkTitle}>
          {language.authForm.resetPassword}
          <NavLink to={routes.SEND_EMAIL} className={s.link}>
            {language.authForm.resetPasswordLink}
          </NavLink>
        </p>
      )}
    </div>
  );
};

export default AuthLinkGroup;
